import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { UserDTO } from '../../domain/user/user.model';

import { MatButton } from '@angular/material/button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-mail-confirm',
  templateUrl: 'mail-confirm.component.html',
  styleUrls: ['mail-confirm.component.scss'],
  imports: [MatButton, TranslatePipe],
})
export class MailConfirmComponent implements OnInit {
  readonly sendMailEvent = output();
  readonly returnToDrClickEmitter = output<boolean>();

  mailConfirmationText: string = '';

  readonly user = input<UserDTO | null>(null);
  readonly isComingFromDrClick = input<boolean>(false);

  constructor(private ts: TranslateService) {}

  ngOnInit(): void {
    // Imposta il testo di conferma in base all'utente
    if (this.user()) {
      this.mailConfirmationText =
        this.user()?.idAnagrafica === -1
          ? // The token has expired
            `${this.ts.instant('dottnet.confirmMail.text.expired')}`
          : // If the user is reaching the component after the signup process
            `${this.ts.instant('dottnet.confirmMail.text')}`;
    }
  }

  sendMail() {
    this.sendMailEvent.emit();
  }

  returnToDrClick() {
    this.returnToDrClickEmitter.emit(true);
  }
}
